var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"error-container"},[_c('div',{staticClass:"background"}),_c('div',{staticClass:"error-title-container"},[_c('h1',[_vm._v(_vm._s(_vm.$lang.error.error_title))]),_c('p',[_vm._v(_vm._s(_vm.$lang.error.error_desc))]),_c('a',{staticClass:"back-home",on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.$lang.about.home))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }